import Wheel from "../../wheel/Wheel.js";
export default function render() {
  return (
    <div className="main">
      <Wheel coeffs={this.state.wheelCoefs}></Wheel>
      {/* <button onClick={this.addBall}>Add ball</button> */}
      <canvas
        id="myCanvas"
        width="315"
        height="375"
        style={{
          backgroundColor: "rgba(97,104,175,1)",
        }}
      />
    </div>
  );
}
